import { render, staticRenderFns } from "./Change.html?vue&type=template&id=b0ab885c&scoped=true&"
import script from "./Change.js?vue&type=script&lang=js&"
export * from "./Change.js?vue&type=script&lang=js&"
import style0 from "./Change.scss?vue&type=style&index=0&id=b0ab885c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ab885c",
  null
  
)

export default component.exports